import { hundredsRows } from "@/lib/tool-kit/worksheets/charts";

const EXACT_COLOR = {
  printColorAdjust: "exact",
  WebkitPrintColorAdjust: "exact",
} as const;

/** A number chart ten across, with shaded and blank cells. */
export function HundredsGrid({
  numbers,
  shaded,
  blanks,
  fontPoints,
  label,
}: {
  numbers: readonly number[];
  shaded: ReadonlySet<number>;
  /** Numbers to leave empty; null shows them all. */
  blanks: ReadonlySet<number> | null;
  fontPoints: number;
  label: string;
}) {
  return (
    <table
      aria-label={label}
      className="w-full table-fixed border-collapse text-center font-mono tabular-nums"
      style={{ fontSize: `${fontPoints}pt`, ...EXACT_COLOR }}
    >
      <tbody>
        {hundredsRows(numbers).map((row) => (
          <tr key={row[0]}>
            {row.map((n) => (
              <td
                className={`border border-neutral-700 py-[0.45em] ${shaded.has(n) ? "bg-neutral-300 font-bold" : ""}`}
                key={n}
              >
                {blanks?.has(n) ? "" : n}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
